import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ov-logo',
  templateUrl: './ov-logo.component.html',
  styleUrls: ['./ov-logo.component.scss']
})
export class OvLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
